/* eslint-disable */
export default {
  forward: 'Doorverbinden',
  ignore: 'Negeren',
  toVoicemail: 'Naar voicemail',
  answer: 'Beantwoorden',
  endAndAnswer: 'Beëindigen en beantwoorden',
  holdAndAnswer: 'In wacht en beantwoorden',
  custom: 'Aangepast',
  more: 'Meer',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
